import { createAction, props } from '@ngrx/store';

export const loadIfaSelectProductType = createAction('[IfaSelectProductType] Load IfaSelectProductType', props<{ productId: string }>());
